import router from "@/router/index";
import {
  jumpToSuperpay,
  joinSuperPayUrl,
  postOfferFactory
} from "@/utils/superpay.js";
import { creatUUid } from "@/utils/lodash";
import {
  createOrder,
  loginByMasterId,
  getSettingData,
  getServiceList
} from "@/service/service.js";
import { payByWebPayPal } from "@/service/service";
import { recordFirstEnterTimeStamp, recordEnterTimes } from "@/utils/payment";

export default {
  updateImageSrc({ commit, state }, payload) {
    commit("updateImageSrc", payload.image_src);
  },
  updateScheme({ commit, state }, payload) {
    commit("updateScheme", payload.source_scheme);
  },
  updatePlatform({ commit, state }, payload) {
    commit("updatePlatform", payload.platform);
  },
  updateUsername({ commit, state }, payload) {
    commit("updateUsername", payload.username);
  },
  updateFullname({ commit, state }, payload) {
    commit("updateFullname", payload.full_name);
  },
  updateFollowCount({ commit, state }, payload) {
    //follow_count

    commit("updateFollowCount", payload.follow_count);
  },
  updateLikeCount({ commit, state }, payload) {
    //like_count

    commit("updateLikeCount", payload.like_count);
  },
  updateViewCount({ commit, state }, payload) {
    //view_count

    commit("updateViewCount", payload.view_count);
  },
  updateCommentCount({ commit, state }, payload) {
    //commment_count

    commit("updateCommentCount", payload.comment_count);
  },
  updateLikeTabData({ commit, state }, payload) {
    //like页面顶部data

    commit("updateLikeTabData", payload.likeTabData);
  },
  updateProductKind({ commit, state }, payload) {
    commit("updateProductKind", payload.product_kind);
  },
  updateUserJson({ commit, state }, payload) {
    commit("updateUserJson", payload.userJson);
  },
  updateUserCoin({ commit, state }, payload) {
    commit("updateUserCoin", payload.user_coin);
  },
  updateTaskJson({ commit, state }, payload) {
    commit("updateTaskJson", payload.taskJson);
  },
  updateConfirmShow({ commit, state }, payload) {
    commit("updateConfirmShow", payload.confirmShow);
  },
  updateSettingData({ commit, state }, payload) {
    commit("updateSettingData", payload.settingData);
  },
  updateGetType({ commit, state }, payload) {
    commit("updateGetType", payload.getType);
  },
  updateOfferId({ commit, state }, payload) {
    commit("updateOfferId", payload.offer_id);
  },
  updateHistoryBackShow({ commit, state }, payload) {
    commit("updateHistoryBackShow", payload.historyBack);
  },
  updateCoinShow({ commit, state }, payload) {
    commit("updateCoinShow", payload.coinShow);
  },
  updateCollectShow({ commit, state }, payload) {
    commit("updateCollectShow", payload.collectShow);
  },
  updateSchemeUrl({ commit, state }, payload) {
    commit("updateSchemeUrl", payload.schemeUrl);
  },
  updateTaskJsonSign({ commit, state }, payload) {
    commit("updateTaskJsonSign", payload.taskJsonSign);
  },
  updateAppKind({ commit, state }, payload) {
    commit("updateAppKind", payload.appKind);
  },
  updateDataUrl({ commit, state }, payload) {
    commit("updateDataUrl", payload.dataUrl);
  },
  updateTabSeleced({ commit, state }, payload) {
    commit("updateTabSeleced", payload.tabSeleced);
  },
  updateLoadingShow({ commit, state }, payload) {
    commit("updateLoadingShow", payload.loadingShow);
  },
  updateMver({ commit, state }, payload) {
    commit("updateMver", payload.mver);
  },
  updateMidLoadingShow({ commit, state }, payload) {
    commit("updateMidLoadingShow", payload);
  },
  updatePostData({ commit, state }, payload) {
    commit("updatePostData", payload.postData);
  },
  updateNavTitleName({ commit, state }, payload) {
    commit("updateNavTitleName", payload.navTitleName);
  },
  updateTabbarShow({ commit, state }, payload) {
    commit("updateTabbarShow", payload.tabbarShow);
  },
  updateMtStatus({ commit, state }, payload) {
    commit("updateMtStatus", payload.mtStatus);
  },
  async initApp({ commit, state, dispatch }, payload) {
    // first time stamp
    recordFirstEnterTimeStamp();
    // enter time
    recordEnterTimes();
    //upadte masterID:
    dispatch("updateMasterId").catch();
    //login by gx:
    dispatch("loginByMasterId", {
      masterId: state.masterId,
      userId: state.masterId
    }).catch();
    //拉取setting:
    await dispatch("updateSettingData").catch();
    //拉取service list:
    dispatch("updateServiceList").catch();
  },
  async updateServiceList({ commit, state, dispatch }, payload) {
    try {
      const response = await getServiceList(state.masterId);
      commit("upadteServiceList", response.data.data);
      return response;
    } catch (error) {
      console.log("getServiceList error:", error);
      return Promise.reject(error);
    }
  },
  async updateSettingData({ state, commit, dispatch }) {
    try {
      const response = await getSettingData();
      console.log("response?", response);
      commit("updateSettingData", {
        settingData: response.data.data
      });
      return response;
    } catch (error) {
      console.log("updateSettingData error:", error);
      return Promise.reject(error);
    }
  },
  updateToastShow({ commit }, payload) {
    commit("updateToastShow", payload);
    setTimeout(() => {
      commit("updateToastShow", {
        toastShow: false,
        toastText: "",
        position: ""
      }); //2s后自动消失
    }, 2500);
  },
  updateMasterId({ commit, state }) {
    if (state.masterId === "") {
      commit("updateMasterId", creatUUid());
    }
  },
  async loginByMasterId({ state }, payload) {
    //login
    try {
      const { masterId, userId } = payload;
      const response = await loginByMasterId(masterId, userId);
      console.log("loginByMasterId resppose:", response);
      return response;
    } catch (error) {
      console.log("loginByMasterId erro:", error);
      return Promise.reject(error);
    }
  },
  payByAny({ commit }, payload) {
    router.push({
      name: "payment",
      query: {
        offer: JSON.stringify(payload)
      }
    });
  },
  payBySuperPay({ commit }, payload) {
    //superpay相当于iap支付;
    const { offer, schemeUrl } = payload;
    //URL:
    const payUrl = joinSuperPayUrl(postOfferFactory(offer), offer, schemeUrl);
    //跳转
    jumpToSuperpay(payUrl);
  },
  async payByPayPal({ commit, dispatch, getters, state }, payload) {
    try {
      const { offer } = payload;
      const { settingData } = state;
      const baseUrl = settingData.client_settings.paypal.web_pay_url;
      payByWebPayPal({
        baseUrl,
        offer
      });
      return;

      const response = await createOrder(offer);
      console.log("payByPayPal result:", response);
      if (response.data.result == "succ") {
        dispatch("updatePostData", {
          postData: {
            button_id: response.data.button_id,
            custom: response.data.uuid
          }
        });
        //form手动提交
        setTimeout(() => {
          document.getElementById("post-form").submit();
        }, 200);
      } else {
        dispatch("updateToastShow", {
          //失败Toast
          toastShow: true,
          toastText: "Oops,Post data failed,please try again."
        });
      }
    } catch (error) {
      dispatch("updateToastShow", {
        //失败Toast
        toastShow: true,
        toastText: "Oops,Post data failed,please try again."
      });

      return Promise.reject(error);
    }
  }
};



// WEBPACK FOOTER //
// ./src/vuex/action.js